<template>
  <div>
    <span class="day">{{ event.created | date }}</span>

    <span v-if="event.benefit.descriptionShort">
      {{ event.benefit.name }}
      <br />
      {{ event.benefit.descriptionShort }}
    </span>

    <span v-else>{{ event.benefit.name }}</span>

    <span class="partner">
      <b>{{ event.benefit.place.name }}</b>

      <br />
      {{ event.benefit.place | address }}
    </span>
  </div>
</template>

<script>
/**
 * @vuese
 * Pojedynczy rekord historii wykorzystanych usług
 * @group History
 */
export default {
  props: {
    // zdarzenie użycia
    event: {
      type: Object,
      required: true
    }
  }
};
</script>